import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IPushNotificationTemplate } from 'src/app/modules/templates/interfaces/template-list-response.interface';

@Component({
  selector: 'app-push-notification-template-preview',
  templateUrl: './push-notification-template-preview.component.html',
  styleUrls: ['./push-notification-template-preview.component.scss'],
})
export class PushNotificationTemplatePreviewComponent implements OnChanges {
  @Input() formData: IPushNotificationTemplate;
  @Input() isCalledFromCreation: boolean;
  title = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formData']?.currentValue) {
      this.formData = changes['formData'].currentValue;
      if (this.formData?.title === '#title#') {
        this.title = 'Dynamic Title';
      } else {
        this.title = this.formData?.title;
      }
    }
  }
}
